import { render } from "./IdCard.vue?vue&type=template&id=1a41997c"
import script from "./IdCard.vue?vue&type=script&lang=js"
export * from "./IdCard.vue?vue&type=script&lang=js"

import "./IdCard.vue?vue&type=style&index=0&id=1a41997c&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__